import React, { Component } from 'react';
import AdvBasicTable from './AdvBasicTable';
import SimpleTable from './SimpleTable';

/*
export class AdvVerticalData extends Component {
  render() {
    return (
      <div className="media-body">
        <h4 className="mt-0">{this.props.title}</h4>
        <div className="py-4">
          {this.props.rows.map((item) => (
            <p key={item.key} className="clearfix">
              <span className="float-left">{item.title}</span>
              <span className="float-right text-muted">
                {this.props.data[item.key]}
              </span>
            </p>
          ))}
        </div>
      </div>
    );
  }
}
*/

export class AdvVerticalData extends Component {
  render() {
    return (
      <div>
        {this.props.title && <h3>{this.props.title}</h3>}
        <AdvBasicTable
          noHead
          columns={[
            { key: 'name', title: '', leftAligned: true },
            { key: 'value', title: '', leftAligned: true },
          ]}
          data={this.props.rows.map((row) => ({
            name: row.title,
            value: this.props.data[row.key],
          }))}
        />
      </div>
    );
  }
}

export default AdvVerticalData;
